module.exports = __webpack_public_path__ + "static/media/mw.6073ddcf.svg";